
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.648 7a3 3 0 100-6 3 3 0 000 6zM4.647 14a3 3 0 100-6 3 3 0 000 6zM16.648 21a3 3 0 100-6 3 3 0 000 6zM7.237 12.51l6.83 3.98M14.057 5.51l-6.82 3.98","stroke":"#175F69","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    